import React from 'react';
import PropTypes from 'prop-types';

import UTTouchableWithoutFeedback from '../../../../../../components/UTTouchableWithoutFeedback';
import UTModal from '../../../../../../components/UTModal';

import styles from './styles';

class Thumbnail extends React.Component {
  state = { modalIsOpen: false };

  openModal = () => this.setState({ modalIsOpen: true });

  closeModal = () => this.setState({ modalIsOpen: false });

  render() {
    const { imageModal, imageThumbnail } = this.props;
    return (
      <div>
        <UTTouchableWithoutFeedback onClick={this.openModal}>
          <img alt="" src={imageThumbnail} style={styles.thumbnail} />
        </UTTouchableWithoutFeedback>
        <UTModal imageModal isOpen={this.state.modalIsOpen} onRequestClose={this.closeModal}>
          <div style={styles.modalwrapper}>
            <img alt="" src={imageModal} style={styles.modalimage} />
          </div>
        </UTModal>
      </div>
    );
  }
}

Thumbnail.propTypes = {
  imageModal: PropTypes.string.isRequired,
  imageThumbnail: PropTypes.string.isRequired
};

export default Thumbnail;
